module.exports = __webpack_public_path__ + "assets/GoldPhi2x.81f5e3f1adf5fe3262341636a2bf5add.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldPhi2x.png
// module id = 818
// module chunks = 0